import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDisclaimerGroupComponent, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoPageSlideComponent, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { Veiculo } from 'src/app/estoque/romaneio/interface/veiculo';
import { VeiculoLookupService } from 'src/app/estoque/romaneio/service/veiculo-lookup-service';
import { Zpr } from 'src/app/interface/zpr';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { FiltroGuaritaLista } from '../filtro/filtro-lista-faturamento-guarita';
import { DanfeService } from '../../service/danfe-service';
import { PedidoService } from '../../service/pedido.service';
import { getPedidoGuaritaDefault, getStatusFaturamentoDefault, PedidoGuaritaDto, StatusFaturamento } from '../../interface/pedido';
import { Transportadora } from 'src/app/interface/transportadora';
import { TransportadoraService } from 'src/app/service/transportadora-service';
import { AuthService } from 'src/app/service/auth.service';
import { FinReceberService } from 'src/app/financeiro/service/fin-receber.service';
import { defaultPagamentoTituloLista, PagamentoTituloLista } from 'src/app/interface/titulo';
import { FiltroListaTitulo } from '../../filter/filtro-lista-titulo';


@Component({
  selector: 'app-faturamento-guarita-lista',
  templateUrl: './faturamento-guarita-lista.component.html',
  styleUrls: ['./faturamento-guarita-lista.component.css']
})
export class FaturamentoGuaritaListaComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroGuaritaLista;

  pedidoSelecionado: PedidoGuaritaDto = getPedidoGuaritaDefault();

  guarita: string = '';
  guaritaNome: string = '';

  complemento: string = '';

  valorTotalTitulos: number = 0;

  listaTitulosCliente: PagamentoTituloLista = defaultPagamentoTituloLista();
  filtroTitulos: FiltroListaTitulo = new FiltroListaTitulo();

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  guaritaAdvancedFilters: Array<PoDynamicFormField>;
  guaritaColumnsFilters: Array<PoLookupColumn>;
  guaritaFieldFormaterFilters: (value: Zpr) => string;

  veiculoAdvancedFilters: Array<PoDynamicFormField>;
  veiculoColumnsFilters: Array<PoLookupColumn>;
  veiculoFieldFormaterFilters: (value: Veiculo) => string;

  advancedTransportadoraFilters: Array<PoDynamicFormField>;
  columnsTransportadoraFilters: Array<PoLookupColumn>;
  fieldFormaterTransportadoraFilters: ((value: Transportadora) => string);

  statusFaturamento: StatusFaturamento = getStatusFaturamentoDefault();
  btnGerarDanfeDisabled: boolean = true;

  podeFaturarComplemento: boolean = false;

  constructor(
    private router: Router,
    private poStorageService: PoStorageService,
    private poNotificationService: PoNotificationService,
    private pedidoService: PedidoService,
    private danfeService: DanfeService,
    private poDialog: PoDialogService,
    private finReceberService: FinReceberService,
    public zprLookupService: ZprLookupService,
    public veiculoLookupService: VeiculoLookupService,
    public transportadoraService: TransportadoraService,
    private authService: AuthService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroGuaritaLista(this.poStorageService);

    this.zprLookupService.grupo      = 'GUARITA';
    this.guaritaAdvancedFilters      = this.zprLookupService.getAdvancedFilter();
    this.guaritaColumnsFilters       = this.zprLookupService.getColumnsFilter();
    this.guaritaFieldFormaterFilters = this.zprLookupService.getFieldFormater;

    this.veiculoAdvancedFilters      = this.veiculoLookupService.getAdvancedFilter();
    this.veiculoColumnsFilters       = this.veiculoLookupService.getColumnsFilter();
    this.veiculoFieldFormaterFilters = this.veiculoLookupService.getFieldFormater;

    this.advancedTransportadoraFilters = this.transportadoraService.getAdvancedFilter();
    this.columnsTransportadoraFilters = this.transportadoraService.getColumnsFilter();
    this.fieldFormaterTransportadoraFilters = this.transportadoraService.getFieldFormater;

  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('pageSlide', { static: true }) pageSlide!: PoPageSlideComponent;
  @ViewChild('modalStatusFaturamento', { static: true }) modalStatusFaturamento!: PoModalComponent;
  @ViewChild('listaTitulosModal', { static: true }) listaTitulosModal!: PoModalComponent;

  ngOnInit(): void {

    this.authService.validaPrivilegio(["PO_FAT_PEDIDO_COMPLEMENTA", "PORTAL_ADMINISTRADOR"]).then((ret) => {
      this.podeFaturarComplemento = ret;

      if (this.tabelaPrincipalFiltro.dados.CC5GUARITA != '') {
        this.tabelaPrincipalLoad();
      }

    });


  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();
    this.tabelaPrincipalFiltro.dados.CLISTACOMPLEMENTO = this.podeFaturarComplemento ? 'S' : 'N';

    this.guarita = this.tabelaPrincipalFiltro.dados.CC5GUARITA;

    this.zprLookupService.getObjectByValue(this.guarita.trim()).subscribe((ret) => {
      this.guaritaNome = ret.CZPRGENERI;
    });

    this.pedidoService.listaPedidosGuarita(this.guarita, this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items.map((item) => {
        return { ...item, favorite: ['view', 'titulos'] };
      });
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CC5NUM'       , label: 'Pedido'       },
    {
      property: 'CC5TIPO',
      label: 'Tipo',
      type: 'label',
      labels: [
        { value: 'N', color: 'color-11', label: 'Normal' },
        { value: 'B', color: 'color-07', label: 'Utiliza Fornecedor' },
      ]
    },
    {property: 'CZACFAZENDDESC', label: 'Fazenda'     },
    {property: 'CC5CLIENTE'   , label: 'Cod Cliente'  },
    {property: 'CC5LOJACLI'   , label: 'Loja'         },
    {property: 'CA1NREDUZ'    , label: 'Cliente'      },
    {property: 'DC5EMISSAO'   , label: 'Emissão' , type: 'date', format: 'dd/MM/yyyy'},
    {property: 'favorite'     , label: '...'     , width: '10%', type: 'icon',
      icons: [
        {
          action: this.view.bind(this),
          icon: 'po-icon-edit',
          tooltip: 'View',
          value: 'view',
        },
        {
          action: this.listaTitulos.bind(this),
          icon: 'po-icon-finance',
          tooltip: 'Títulos',
          value: 'titulos',
          disabled: this.disableListaTitulos.bind(this)
        },
      ]
    }
  ];

  public readonly colunasItens: Array<PoTableColumn> = [
    {property: 'CC6ITEM'                , label: 'Item'               , width: '5%'         },
    {property: 'CZACPROJET'             , label: 'Projetos'           , width: '10%'        },
    {property: 'CC6PRODUTO'             , label: 'Produto'            , width: '15%'        },
    {property: 'CB1DESC'                , label: 'Descrição'          , width: '25%'        },
    {property: 'CC6UM'                  , label: 'UM'                 , width: '5%'         },
    {property: 'NC6QTDVEN'              , label: 'Quantidade'         , type: 'number'       , format: '1.2-2'},
    {property: 'NC6QTDENT'              , label: 'Quantidade Entregue', type: 'number'       , format: '1.2-2'},
    {property: 'NC6PRCVEN'              , label: 'Valor Unitário'     , type: 'currency'     , format: 'BRL'},
    {property: 'NQTDENT'                , label: 'Qtd à Faturar'      , type: 'cellTemplate'},
    {property: 'NQTDPENENT'             , label: 'Qtd Pend à Faturar' , type: 'number'       , format: '1.2-2'},
    {property: 'NVALORFAT'              , label: 'Valor Faturamento'  , type: 'currency'     , format: 'BRL'},
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Notas Guarita', action: this.goHome.bind(this) },
      { label: 'Lista' }
    ]
  };

  public readonly colunasTitulos: Array<PoTableColumn> = [
    {property: 'CE1FILIAL' , label: 'Filial'         },
    {property: 'CE1NUM'    , label: 'Número'         },
    {property: 'CE1TIPO'   , label: 'Tipo'           },
    {property: 'DE1EMISSAO', label: 'Emissão'        , type: 'date'    , format: 'dd/MM/yyyy'},
    {property: 'DE1VENCTO' , label: 'Vencimento'     , type: 'date'    , format: 'dd/MM/yyyy'},
    {property: 'DE1VENCREA', label: 'Vencto Real'    , type: 'date'    , format: 'dd/MM/yyyy'},
    {property: 'NE1VALOR'  , label: 'Valor'          , type: 'currency', format: 'BRL'},
    {property: 'NE1SALDO'  , label: 'Saldo'          , type: 'currency', format: 'BRL'},
  ];

  view(row: PedidoGuaritaDto): void {
    this.pedidoService.getPedidoGuarita(row.CC5NUM).subscribe((pedido) => {
      this.pedidoSelecionado = {...pedido, NC5REMSIMB: 0};
      this.pedidoSelecionado.items = this.pedidoSelecionado.items.map((item) => {
        let qtdEnt = item.NC6QTDVEN - item.NC6QTDENT;
        if (qtdEnt < 0) {
          qtdEnt = 0;
        }
        return {...item, NQTDENT: 0, NQTDMAXENT: qtdEnt, NQTDPENENT: qtdEnt, NVALORFAT: (qtdEnt * item.NC6PRCVEN)};
      });
      if (this.pedidoSelecionado.CC5EHCOMP == 'S') {
        this.complemento = "(Complemento)";
      } else {
        this.complemento = "";
      }
      this.pageSlide.open();
      this.statusFaturamento = getStatusFaturamentoDefault();
      this.atualizaBtnGerarDanfe();
    });
  }

  confirmaFaturarPedido(): void {
    let txt = "";
    if (this.pedidoSelecionado.CC5EHCOMP == 'S') {
      txt = "Deseja realmente faturar o pedido complementar?";
    } else {
      txt = "Deseja realmente confirmar o faturamento com os dados preenchidos?";
    }
    this.poDialog.confirm({
      title: 'Confirmar o Faturamento',
      message: txt,
      confirm: () => this.faturarPedido()
    });
  }

  faturarPedido(): void {
    if (this.verificaValores()) {
      this.statusFaturamento = getStatusFaturamentoDefault();
      this.pedidoService.postLiberaPedido(this.pedidoSelecionado).subscribe((ret) => {
        this.statusFaturamento = {...this.statusFaturamento, ...ret};
        this.atualizaBtnGerarDanfe();
        this.pageSlide.close();
        this.modalStatusFaturamento.open()
      });
    }
  }

  verificaValores(): boolean {
    let podeFaturar = false;
    let comErro = false;

    this.pedidoSelecionado.items.map((item) => {
      if (item.NQTDENT > (item.NC6QTDVEN - item.NC6QTDENT)) {
        comErro = true;
        this.poNotificationService.warning(`Quantidade de Entrega do item ${item.CC6ITEM} inválida. Valor máximo ${item.NC6QTDVEN - item.NC6QTDENT}.`)
      }
      item.NVALORFAT = item.NQTDENT * item.NC6PRCVEN;
      item.NQTDPENENT = item.NQTDMAXENT - item.NQTDENT;

      if (item.NQTDENT > 0) {
        podeFaturar = true;
      }

      return {...item};
    });

    if (this.pedidoSelecionado.CC5EHCOMP != 'S') {
      if (!this.pedidoSelecionado.CF2TRANSP) {
        this.poNotificationService.error(`Por favor, informe a transportadora.`);
        return false;
      } else if (!this.pedidoSelecionado.CPLACA) {
        this.poNotificationService.error(`Por favor, informe a placa do veículo.`);
        return false;
      } else if (!this.pedidoSelecionado.DC5DTCORTE) {
        this.poNotificationService.error(`Por favor, informe a data de corte.`);
        return false;
      } else if (!this.pedidoSelecionado.CF2ROMANEI) {
        this.poNotificationService.error(`Por favor, informe o Número do Romaneio.`);
        return false;
      } else if (this.pedidoSelecionado.CC5TIPO == 'B' && (this.pedidoSelecionado.NC5REMSIMB == undefined ||this.pedidoSelecionado.NC5REMSIMB == 0)) {
        this.poNotificationService.error(`Para pedidos Utiliza Fornecedor, é necessário informar o campo de Remessa Simbólica.`);
        return false;
      }
    }

    if (!podeFaturar) {
      this.poNotificationService.error(`Nenhum item com quantidade maior que zero.`);
      return false;
    } else if (comErro) {
      this.poNotificationService.error(`Item com quantidade de faturamento inválida.`);
      return false;
    }

    return true;
  }


  public readonly atualizaStatusFaturamento: PoModalAction = {
    action: () => {
      this.atualizaStatusFaturamentoF();
    },
    label: 'Atualizar'
  };

  atualizaStatusFaturamentoF(): void {
    this.pedidoService.statusFaturamento(this.statusFaturamento.NREGSC9).subscribe((ret) => {
      this.statusFaturamento = ret;
      this.atualizaBtnGerarDanfe();
    })
  }

  gerarDanfe(): void {
    this.danfeService.getDanfeII(this.statusFaturamento.CC9SERIENF, this.statusFaturamento.CC9NFISCAL).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `${this.statusFaturamento.CF3CHVNFE}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  }

  atualizaBtnGerarDanfe(): void {
    this.btnGerarDanfeDisabled = this.statusFaturamento.CF3CHVNFE == '';
  }

  listaTitulos(row: PedidoGuaritaDto): void {
    this.filtroTitulos.setDefault();
    this.filtroTitulos.dados.CE1FILIAL = 'ALL';
    this.filtroTitulos.dados.CE1CLIENTE = row.CC5CLIENTE;
    this.filtroTitulos.dados.CE1LOJA = row.CC5LOJACLI;
    this.filtroTitulos.dados.order = 'E1_VENCTO';
    this.valorTotalTitulos = 0;
    this.finReceberService.listaTitulos(this.filtroTitulos.dados).subscribe((ret) => {
      ret.items.map((item) => {
        this.valorTotalTitulos += item.NE1SALDO;
      });
      this.listaTitulosCliente = ret;
      this.listaTitulosModal.open();
    })
  }

  disableListaTitulos(row: PedidoGuaritaDto): boolean {
    return row.CC5TIPO == 'B';
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
